import React, { useEffect, useState } from "react";

export default function UnauthenticatedContainer({
  children,
}: {
  children?: React.ReactNode;
}) {
  const [showChildren, setShowChildren] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("uuid")) {
      setShowChildren(false);
    } else {
      setShowChildren(true);
    }
  }, [setShowChildren]);

  return <div>{showChildren ? children : null}</div>;
}
